/**
 * quizCeremonieAm.js — Quiz Kahoot LIVE de la Cérémonie de fin de formation AM.
 * Reprend les 10 questions du QCM final de la cérémonie S5 (référentiel officiel).
 * Format standard aligné sur quizJournee1Am / quizJournee2Am pour compatibilité QuizHost.
 *
 * Se lance en Kahoot (QR code projecteur, élève+parents sur leur téléphone),
 * puis le prof clique "Continuer cérémonie" → carte permis animée.
 */
export const quiz = {
  id: 'ceremonie-am',
  title: 'Cérémonie AM · QCM Final Kahoot',
  color: '#eab308', // jaune-doré (cérémonie)
  cours: '/permis-am/ceremonie',
  questions: [
    {
      q: 'À 45 km/h, en cas de danger, il te faut environ...',
      choices: ["3 m pour t'arrêter", "13 m pour t'arrêter", "30 m pour t'arrêter", "50 m pour t'arrêter"],
      answer: 1,
      explain: '13 m ≈ 3 voitures alignées. Sur route mouillée, cette distance DOUBLE.',
    },
    {
      q: "Un pot d'échappement modifié = combien d'amende ?",
      choices: ["Rien, c'est légal", "Jusqu'à 45 €", "Jusqu'à 135 €", "Jusqu'à 450 €"],
      answer: 3,
      explain: "Jusqu'à 450 € + confiscation possible du véhicule. Et l'assurance peut refuser toute prise en charge.",
    },
    {
      q: 'Un copain veut débrider ton scooter. Tu :',
      choices: [
        "Acceptes, c'est plus fun",
        'Refuses : assurance annulée + gendarmes + risque moteur',
        "Acceptes mais ne le dis pas à tes parents",
        "Le fais toi-même en cachette",
      ],
      answer: 1,
      explain: "Débridage = assurance nulle (tes parents paient à vie en cas d'accident) + 135 € d'amende + cadre fragilisé (conçu pour 45 km/h, pas 70+).",
    },
    {
      q: 'Un ami te propose de consommer du cannabis avant de rouler. Tu :',
      choices: [
        "Acceptes, une seule fois ne change rien",
        'Refuses ET laisses le scooter, tu rentres autrement',
        "Prends le scooter quand même mais roules doucement",
        "Refuses mais prends le scooter",
      ],
      answer: 1,
      explain: 'Cannabis = perception du danger réduite pendant 6 à 8 heures. Même sans effet ressenti, tes réflexes sont KO. Alcool + cannabis = ×14 le risque d\'accident mortel.',
    },
    {
      q: 'Sur route MOUILLÉE, ta distance de freinage à 45 km/h passe à...',
      choices: ['La même : 13 m', '20 m environ', '26 m environ', '40 m environ'],
      answer: 2,
      explain: 'Sur mouillé, la distance de freinage DOUBLE. Il faut couper les gaz et ralentir à chaque averse.',
    },
    {
      q: 'Un piéton heurté à 50 km/h par un scooter a environ...',
      choices: [
        "1 chance sur 10 d'y rester",
        "1 chance sur 4 d'y rester",
        "1 chance sur 2 d'y rester",
        "1 chance sur 100 d'y rester",
      ],
      answer: 2,
      explain: "1 chance sur 2. À 30 km/h, cette probabilité descend à 10%. C'est pour ça qu'aux abords d'école, on coupe les gaz et on ralentit.",
    },
    {
      q: 'Ton meilleur pote fait un wheeling devant toi. Tu :',
      choices: [
        "Fais pareil, c'est marrant",
        "Le filmes pour TikTok",
        'Continues à ton allure, tu ne le suis pas',
        "L'encourages en klaxonnant",
      ],
      answer: 2,
      explain: 'Un défi filmé = 3 secondes de vue, 30 ans de conséquences. Tu conduis TON scooter, pas celui du copain.',
    },
    {
      q: 'Le principal risque en cyclomoteur, c\'est :',
      choices: [
        'Une chute basse vitesse (parking, giratoire)',
        'Un refus de priorité par une voiture',
        "Une portière qui s'ouvre",
        'Toutes les 3 réponses ci-dessus',
      ],
      answer: 3,
      explain: "Les 3 risques sont majeurs. En ville, roule à 1 m des voitures garées, méfie-toi des angles morts, et anticipe les intersections.",
    },
    {
      q: 'Tu vérifies tes pneus, freins et feux :',
      choices: [
        'Une fois par an au contrôle',
        'Une fois par mois',
        'Une fois par semaine',
        "Jamais, c'est le rôle du garage",
      ],
      answer: 2,
      explain: "1 fois par semaine minimum. C'est ta responsabilité de futur conducteur autonome.",
    },
    {
      q: 'Combien de mètres parcours-tu en 1 SECONDE de distraction à 45 km/h ?',
      choices: ['4 m', '8 m', '12,5 m', '20 m'],
      answer: 2,
      explain: "12,5 m les yeux ailleurs. Un SMS, une notif, un coup d'œil sur ton téléphone → l'équivalent d'un passage piéton complet aveugle.",
    },
  ],
};

export default quiz;
